// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6dddffd8","498":"1cc32b35","513":"24fa2b55","647":"f3cf4254"}[chunkId] + ".chunk.js";
};